import { render, staticRenderFns } from "./BanReaperWidgetPreview.vue?vue&type=template&id=6c10ab43"
import script from "./BanReaperWidgetPreview.vue?vue&type=script&lang=js"
export * from "./BanReaperWidgetPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports